import { LOG_OUT } from '../store/store-models/authentication-model';
import { RESET_STATE as rs1 } from '../store/store-models/my-pages-company-model';
import { RESET_STATE as rs2 } from '../store/store-models/my-pages-customer-model';
import { RESET_STATE as rs3 } from '../store/store-models/contract-model';
import { RESET_STATE as rs4 } from '../store/store-models/request-model';

export default (store) => {
    store.subscribeAction((action, state) => {
        if(action.type == LOG_OUT){
            store.commit(rs1);
            store.commit(rs2);
            store.commit(rs3);
            store.commit(rs4);
        }
    })
};


// WEBPACK FOOTER //
// ./src/helpers/logout-handler.js